import React, { useState } from "react";
import { Column } from "@ant-design/plots";
import styled from "@emotion/styled";
import { Spin } from "antd";
const StyledTitle = styled.div`
  font-size: 0.9rem;
  font-weight: bold;
  color: #141414;
  margin-bottom: 10px;
`;

const StyledChartContainer = styled.div`
  height: 330px;
  overflow: auto;
  border: solid 1px #9b9b9b;
  border-radius: 3px;
  padding: 10px;
  margin-bottom: 25px;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
  }
`;

function EmployeesPerLocation({ report }) {
  const [displayReportLoader, toggleReportLoader] = useState(false);

  const config = {
    padding: "auto",
    data: report,
    height: 300,
    xField: "location_name",
    yField: "users",
    seriesField: "location_name",
    padding: "auto",
    pixelRatio: 10,
    legend: false,
    label: {
      position: "top",
      // content: '',
    },
    columnStyle: {
      cursor: "pointer",
    },
    xAxis: {
      label: {
        formatter: (value) => value.slice(0, 3).toUpperCase(),
        offset: 10,
        autoHide: false,
        autoRotate: true,
      },
    },
    yAxis: {
      max: 60,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
    theme: {
      colors20: [
        "#0F1C73",
        "#1A449F",
        "#2B67BA",
        "#3C88C0",
        "#4BA7B3",
        "#5AC39B",
        "#6ADD7F",
        "#A8DD6A",
        "#DDDD6A",
      ],
    },
  };
  return (
    <>
      <StyledTitle>Number Of Employees Per Location</StyledTitle>
      <StyledChartContainer>
        <Spin spinning={displayReportLoader}>
          <Column {...config} />
        </Spin>
      </StyledChartContainer>
    </>
  );
}

export default EmployeesPerLocation;
